import React from 'react';
import classNames from 'classnames';

type Spacing = 'none' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
type AsElement = 'div' | 'form' | 'section' | 'header';

type HorizontalContainerProps<T extends AsElement = 'div'> = {
    as?: T;
    children: React.ReactNode;
    spacing?: Spacing;
    className?: string;
    onClick?: () => void;
};

const spacingMap: Record<Spacing, string> = {
    none: '',
    xs: 'gap-2',
    sm: 'gap-4',
    md: 'gap-6',
    lg: 'gap-8',
    xl: 'gap-10',
    xxl: 'gap-12',
};

export const HorizontalContainer = <T extends AsElement = 'div'>({
    as,
    children,
    spacing = 'sm',
    className,
    onClick,
}: HorizontalContainerProps<T>) => {
    const Component = as || 'div';

    return (
        <Component
            onClick={onClick}
            className={classNames('flex', spacingMap[spacing], className)}
        >
            {children}
        </Component>
    );
};
